'use strict';



export default class Info {
	constructor() {
		
		if ($('.nav-special').length > 0){

			if (innerWidth >= 768) { 
			
			//================ Tablet & Desktop ===================//
				
				// On click
				$('.more').on('click',function(){
//					
					$('html,body').animate({scrollTop: $('#more-info').offset().top},'slow');
//					$('.bg-holder, #more-info, .footer-container').addClass('more-activated');
					//$('.footer-container').fadeOut().addClass('more-activated').fadeIn();
					return; 
				});

				$('#return').on('click',function(){
					
					history.pushState("", document.title, window.location.pathname);
					
					$('html,body').animate({ scrollTop: 0 }, 'slow');
					$('.bg-holder, #info').removeClass('more-activated');
					$('.footer-container').removeClass('more-activated').hide().fadeIn();
					return; 
				});
				
				// On scroll
				var timeout;
				$(window).scroll(function() {
					clearTimeout(timeout);
					timeout = setTimeout(function(){

						var activated = $('.bg-holder').hasClass('more-activated');
						if (!activated){
							if ($(window).scrollTop()  > $(window).height()/2) {
								$('.bg-holder, #info, .footer-container').addClass('more-activated');
							}
						} else if (activated) {
							if ($(window).scrollTop()  < $(window).height()/2) {
								$('.more-activated').removeClass('more-activated');
								//$('.hide').removeClass('hide');
							}
						}
					}, 200);
				});
				
				// on Keypress | 'DOWN' keypress actvate info | 'UP' keypress return to top
				$(document).keydown(function(e) {
					switch(e.which) {
						
						case 40: // down
						$('html,body').animate({scrollTop: $('#more-info').offset().top},'slow');
						$('.bg-holder, #info, .footer-container').addClass('more-activated');
						break;
							
						case 38: // up
						$('html,body').animate({ scrollTop: 0 }, 'slow');	
						$('.more-activated').removeClass('more-activated');
						break;

						default: return; // exit this handler for other keys
					}
					e.preventDefault(); 
					// prevent the default action (scroll / move caret)
				});
				
			} else if (innerWidth <= 767) { 
			
			//================ Mobile ===================//
			
				$('.more').on('click',function(){
					$('html,body').animate({ scrollTop: 0 }, 'slow');
					$('#more-info').addClass('more-activated');
					$('.header-container,.options').css('display','none');
					return; 
				});

				$('#more-info #go-back').on('click',function(){
					$('#more-info').removeClass('more-activated');
					$('.header-container,.options').css('display','block');
					return; 
				});

			}
		}
	}
}
